const prefix = 'Options';
export const MODULE_NAME = prefix.toLowerCase();

export const COMPANIES = prefix + 'Companies';
export const CUSTOMERS = prefix + 'Customers';
export const CUSTOMER_OPTIONS = 'customer' + prefix;
export const SET_COMPANIES = `set${prefix}Companies`;
export const CLEAR_COMPANIES = 'clearCompanies';
export const SET_CUSTOMERS = `set${prefix}Customers`;
export const GET_CUSTOMER_OPTION_NAME = `get${prefix}CustomerName`;
export const GET_CUSTOMER_OPTION_IDS = `get${prefix}CustomerIds`;
export const VENDORS = prefix + 'Vendors';
export const SET_VENDORS = `set${prefix}Vendors`;
//integrations Opts
export const INTEGRATIONS_OPTIONS = prefix + 'Integrations';
export const SET_INTEGRATIONS_OPTIONS = `set${prefix}Integrations`;

export const REQUEST_TYPES = 'requestTypes';
export const SET_REQUEST_TYPES = 'setRequestTypes';

export const OEM_LOGS = 'oemLogs';
export const SET_OEM_LOGS = 'setOEMLogs';

export const STATES = prefix + 'States';
export const SET_STATES = `set${prefix}States`;

export const ENVIRONMENTS = prefix + 'Environments';
export const SET_ENVIRONMENTS = `set${prefix}Environments`;
export const SET_USER_OPTIONS = 'setUserOptions';

export const SET_CCL_OPTIONS = `set${prefix}CCL`;

export const ALL_ROLES="allRoles";
export const SET_ALL_ROLES="setAllRoles";

export const INTERNAL_ROLES_OPTS="internalRolesOpts";
export const SET_INTERNAL_ROLES_OPTS="setInternalRolesOpts";

export const CONSULTANT_ROLES_OPTS="consultantRolesOpts";
export const SET_CONSULTANT_ROLES_OPTS="setConsultantRolesOpts";